import { EntityForm } from "../../module/superAdmin/form/EntityFrom";
import { IEntitiesAction, IEntitiesState, Types } from "../types/types";
import {SpecialDay} from "../../module/superAdmin/form/SpecialDay";

const initialState: IEntitiesState = {
  entities: [],
  activeEntity: null,
  initialSettled: null,
  specialDays: [],
};

export const entitiesReducer = (
  state = initialState,
  action: IEntitiesAction
): IEntitiesState => {
  const { type, payload } = action;

  switch (type) {
    case Types.entitiesLoad:
      return {
        ...state,
        entities: payload as EntityForm[],
      };

    case Types.addEntity:
      return {
        ...state,
        entities: [payload as EntityForm, ...state.entities],
      };

    case Types.editEntity:
      return {
        ...state,
        entities: state.entities.map((entity) =>
          entity.id === payload.id ? (payload as EntityForm) : entity
        ),
      };

    case Types.deleteEntity:
      return {
        ...state,
        entities: state.entities.filter((el) => el.id !== (payload as string)),
      };

    case Types.purgeEntities:
      return {
        entities: [],
        activeEntity: null,
        initialSettled: null,
        specialDays: [], // ✅ Reiniciamos esto también
      };

    case Types.purgeActiveEntity:
      return {
        ...state,
        activeEntity: null,
      };

    case Types.setActiveEntity:
      return {
        ...state,
        activeEntity: payload as any,
      };

    case Types.addInitialSettled:
      return {
        ...state,
        initialSettled: payload as string,
      };

    // ✅ NUEVOS CASES PARA DÍAS ESPECIALES
    case Types.specialDaysLoad:
      return {
        ...state,
        specialDays: payload as SpecialDay[],
      };

    case Types.specialDayAdd:
      return {
        ...state,
        specialDays: [...state.specialDays, payload as SpecialDay],
      };

    case Types.specialDayDelete:
      return {
        ...state,
        specialDays: state.specialDays.filter((day) => day.id !== payload),
      };

    default:
      return state;
  }
};
